import axios from 'axios';

/**
 * Fetch user's country code (e.g., 'US', 'EU') using ip-api.com.
 * @returns {Promise<string>} Two-letter country code.
 */
export const getUserRegion = async () => {
  try {
    const response = await axios.get('https://ipapi.co/json/');
    const countryCode = response.data.country_code;
    const americas = ['US', 'CA', 'MX', 'BR', 'AR', 'CL', 'CO', 'PE', 'UY', 'PY', 'BO', 'EC', 'GY', 'SR', 'GF', 'BZ', 'CR', 'SV', 'GT', 'HN', 'NI', 'PA', 'DO', 'HT', 'JM', 'TT', 'BB', 'BS', 'LC', 'VC', 'GD', 'AG', 'DM', 'KN'];
    const eu = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];
    return americas.includes(countryCode) ? 'US' : eu.includes(countryCode) ? 'EU' : 'EU';
  } catch (error) {
    console.error('Error fetching user region:', error);
    return 'EU'; 
  }
};